export default "__VITE_ASSET__ClbJh566__"